import { render, staticRenderFns } from "./VVideo.vue?vue&type=template&id=57739e00&scoped=true&"
import script from "./VVideo.vue?vue&type=script&lang=js&"
export * from "./VVideo.vue?vue&type=script&lang=js&"
import style0 from "./VVideo.vue?vue&type=style&index=0&id=57739e00&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "57739e00",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VIcon } from 'vuetify/lib/components/VIcon';
installComponents(component, {VIcon})
